const rMinSlice = 0;
const rMaxSlice = 2;
const gMinSlice = 2;
const gMaxSlice = 4;
const bMinSlice = 4;
const bMaxSlice = 6;
const aMinSlice = 6;
const aMaxSlice = 8;
const maxColorValue = 255;
const radix = 16;
/**
 * Modifies the opacity of an RGBA or Hex color.
 * @param {string} color - The original color in rgba or hex format (e.g., "rgba(17, 17, 17, 1)" or "#FF0A5965").
 * @param {number} newOpacity - The new opacity value (between 0 and 1).
 * @returns {string} The modified color in rgba format.
 * @throws {Error} If the input color is not in a valid RGBA or Hex format.
 */
export const modifyAlpha = (color, newOpacity) => {
    const rgbaRegex = /^rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([01](?:\.\d+)?)\s*\)$/;
    const hexRegex = /^#([A-Fa-f0-9]{8})$/;
    let r, g, b, a;
    const match = color.match(rgbaRegex);
    if (rgbaRegex.test(color) && match) {
        [, r, g, b, a] = match.map(Number);
    }
    else if (hexRegex.test(color)) {
        const hex = color.slice(1);
        r = parseInt(hex.slice(rMinSlice, rMaxSlice), radix);
        g = parseInt(hex.slice(gMinSlice, gMaxSlice), radix);
        b = parseInt(hex.slice(bMinSlice, bMaxSlice), radix);
        a = parseInt(hex.slice(aMinSlice, aMaxSlice), radix) / maxColorValue;
    }
    else {
        if (color.startsWith('rgba(')) {
            throw new Error('Invalid RGBA color format');
        }
        else {
            throw new Error('Invalid color format');
        }
    }
    // Return the new rgba color with the modified opacity
    return `rgba(${r}, ${g}, ${b}, ${newOpacity})`;
};
//# sourceMappingURL=modifyAlpha.js.map